import { render, staticRenderFns } from "./ServiceRequestServiceOrderAttendantPage.vue?vue&type=template&id=4852308c"
import script from "./ServiceRequestServiceOrderAttendantPage.vue?vue&type=script&lang=js"
export * from "./ServiceRequestServiceOrderAttendantPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports